"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeaturesGridSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _featureGridCard = _interopRequireDefault(require("./feature-grid-card"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index3 = _interopRequireDefault(require("../../../experiments/animation/motion-move/index.js"));
const Container = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "Container",
  class: "pl-c1unmnla"
});
const HeadlineContainer = /*#__PURE__*/(0, _react2.styled)(_index3.default)({
  name: "HeadlineContainer",
  class: "pl-h1xbrrdy"
});
const GridCardContainer = /*#__PURE__*/(0, _react2.styled)(_index3.default)({
  name: "GridCardContainer",
  class: "pl-g1p4ob6w"
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-c9ilbdm"
});

/**
 * FeaturesGridSection component.
 * @module FeaturesGridSection
 *
 * @param {Object} props React props
 * @param {string} props.id Identifier
 * @param {string} props.eyebrow Eyebrow text
 * @param {string} props.heading Heading text
 * @param {string} props.description Description text
 * @param {array} props.items Array of child TileItems
 * @returns {React.ReactElement} FeaturesGridSection component
 * @public
 */

function FeaturesGridSection({
  eyebrow,
  heading,
  description,
  items,
  cta,
  verticalMargin
}) {
  if (!items) return null;
  const gridClass = `grid-${items.length}`;
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    dataCy: "features-grid-section",
    verticalMargin: verticalMargin,
    backgroundColor: _intents.default.ux.box.foregroundColor
  }, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(HeadlineContainer, {
    triggerOnce: true
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    eyebrowTag: "h2",
    eyebrow: eyebrow,
    heading: heading,
    textAlign: "center",
    description: description,
    headlineTag: eyebrow ? 'h3' : 'h2',
    headlineLineLength: 1.15
  })), /*#__PURE__*/_react.default.createElement(GridCardContainer, {
    mode: "fluid",
    intensity: "300",
    variant: "appear",
    triggerOnce: true,
    staggerChildren: true,
    className: gridClass
  }, items?.map((item, i) => /*#__PURE__*/_react.default.createElement(_featureGridCard.default, (0, _extends2.default)({
    key: i
  }, item)))), cta && /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: [cta]
  }))));
}
FeaturesGridSection.propTypes = {
  eyebrow: _propTypes.default.string,
  heading: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_featureGridCard.default.propTypes)),
  cta: _propTypes.default.shape(_merchButton.NSMerchButton.propTypes),
  ..._patternLibraryUtils.marginProps
};